import { Component, Input } from '@angular/core';

import { InfoBoxType } from '../common/info-box/info-box.component';

@Component({
  selector: 'itl-single-order-article-list-item',
  templateUrl: './single-order-article-list-item.component.html',
  styleUrls: ['./single-order-article-list-item.component.scss'],
})
export class SingleOrderArticleListItemComponent {
  @Input() articleNotAvailable: boolean;
  @Input() articleForUse: boolean;
  @Input() isNew: boolean;
  @Input() articleNotFoundInCareproposal: boolean;
  @Input() maxQuantityReached: boolean;
  @Input() isLast: boolean;
  @Input() isInAbo: boolean;
  @Input() articleIsDelayed: boolean;
  @Input() delayedTo: string;
  public showDetailView = false;
  public infoBoxTypeWarning = InfoBoxType.Warning;
  public infoBoxTypeInformation = InfoBoxType.Information;
  public infoBoxInAbo = InfoBoxType.Information;
  public infoBoxSuccess = InfoBoxType.Success;

  public toggleDetailView(): void {
    this.showDetailView = !this.showDetailView;
  }
}
